import Header from 'components/Headers/Header'
import SearchSelectDoorDevices from 'components/Reusable Components/SearchSelectAllDoorDevices';
import SearchSelectAllUsers from 'components/Reusable Components/SearchSelectAllUsers';
import React,{useState,useEffect} from 'react'
import { Card, CardHeader, CardBody, Row, Col, CardImg, Button, Modal, ModalBody,ModalHeader, FormGroup, Input, ModalFooter, Progress, Label,Form,Container} from "reactstrap";
import Select from 'react-select';
import { deviceAdd, newDoorAccessRule } from 'network/ApiAxiosAutomation';

function MainAccess() {
    const [modalNewDevice, setModalNewDevice] = useState(false);
    const [modalAddRule, setModalAddRule] = useState(false);
    const [empId, setEmpId] = useState('');
    const [deviceId, setdeviceId] = useState('');
    const [startTime, setStartTime] = useState(0);
    const [endTime, setEndTime] = useState(24);

    const [newDeviceId, setNewDeviceId] = useState('');
    const [newDeviceName, setNewDeviceName] = useState('');
    const [newDeviceType, setNewDeviceType] = useState('');
    const [newDeviceHouse, setNewDeviceHouse] = useState('');
    const [newDeviceBrand, setNewDeviceBrand] = useState('');

    const role = JSON.parse(localStorage.getItem("user")).role

    const toggleNewDevice = () => setModalNewDevice(!modalNewDevice);
    const toggleAddRule = () => setModalAddRule(!modalAddRule);

    const addDevice = async()=>{
        if(newDeviceId && newDeviceBrand && newDeviceHouse && newDeviceName && newDeviceType){
            // add the new device
            const resp = await deviceAdd(newDeviceId, newDeviceName, newDeviceType.value,newDeviceHouse.value,newDeviceBrand.value )
            if(resp.data.success){
                toggleNewDevice()
            }
        }
    }

    const newRule = async()=>{
        console.log(startTime ? 'true':'false')
        if(empId && deviceId && endTime){
            // add the new rule
            const resp = await newDoorAccessRule(empId, deviceId, startTime, endTime)
            if(resp.data.success){
                toggleAddRule()
            }
        }
    }

  return (<>
    {role=="admin" && <Header/>}
    <Container>
        <Row className="mt--4 mb-4">
            <Col xl="2" xs="4" className="mt-7" >
                <Button onClick={()=>toggleAddRule()}><i className='ni ni-cart mr-1' /> New Rule </Button>
            </Col>
            <Col xl="6" xs="4"></Col>
            <Col xl="4" xs="4" className="mt-7">
                <Button onClick={()=>toggleNewDevice()}><i className='ni ni-album-2 mr-1' /> New Device </Button>
            </Col>
        </Row>
        <Row >
       
        </Row>

        <Modal isOpen={modalNewDevice} toggle={toggleNewDevice} >
            <ModalHeader>Add New Device</ModalHeader>
            <ModalBody>
                <Label>Device ID:</Label>
                <Input type='text' value={newDeviceId} onChange={(e)=>setNewDeviceId(e.target.value)}/>
                <Label className='mt-4'>Device Name:</Label>
                <Input type='text' value={newDeviceName} onChange={(e)=>setNewDeviceName(e.target.value)}/>
                <Label className='mt-4'>Device Type:</Label>
                <Select
                    onChange={setNewDeviceType}
                    options={[{value:'door',label:'Door'},{value:'switch',label:'Switch'}]}
                />
                <Label className='mt-4'>Device Brand:</Label>
                <Select
                    onChange={setNewDeviceBrand}
                    options={[{value:'shelly',label:'Shelly'},{value:'sonoff',label:'Sonoff'}]}
                />
                <Label className='mt-4'>Device Location:</Label>
                <Select
                    onChange={setNewDeviceHouse}
                    options={[
                        {value:'66',label:'Albufeira 66'},
                        {value:'fissa',label:'Albufissa'},
                        {value:'heaven',label:'Heaven'},
                        {value:'tropicana',label:'Tropicana'},
                        {value:'warehouse',label:'Warehouse'},
                        {value:'ticketshop',label:'Ticket Shop'},
                        {value:'hotel',label:'Hotel'},
                        {value:'other',label:'Other'},
                    ]}
                />
            </ModalBody>
            <ModalFooter>
            <Button color="primary" onClick={()=>addDevice()}>
                Save
            </Button>{' '}
            <Button color="secondary" onClick={toggleNewDevice}>
                Cancel
            </Button>
            </ModalFooter>
        </Modal>

        <Modal isOpen={modalAddRule} toggle={toggleAddRule} >
            <ModalHeader>Add New Rule</ModalHeader>
            <ModalBody>
                <Label>User:</Label>
                <SearchSelectAllUsers onSelect={(e)=>setEmpId(e.value)} />
                <Label className='mt-4'>Door:</Label>
                <SearchSelectDoorDevices onSelect={(e)=>setdeviceId(e.value)}/>
                <Label className='mt-4'>Start Time:</Label>
                <Input type='number' value={startTime} onChange={(e)=>setStartTime(e.target.value)} min={0} max={24}/>
                <Label className='mt-4'>End Time:</Label>
                <Input type='number' value={endTime} onChange={(e)=>setEndTime(e.target.value)} min={0} max={24}/>
            </ModalBody>
            <ModalFooter>
            <Button color="primary" onClick={()=>newRule()}>
                Save
            </Button>{' '}
            <Button color="secondary" onClick={toggleAddRule}>
                Cancel
            </Button>
            </ModalFooter>
        </Modal>
      
    </Container>
  </>
  )
}

export default MainAccess